import { combineReducers } from '@reduxjs/toolkit';
import erpSalesReportHomeSummaryReducer from './erpSalesReportHomeSummarySlice';
import erpgetStoreAnnualStatisticsReducer from './erpgetStoreAnnualStatistics';
import erpgetStoreListReducer from './erpgetStoreList';
import erpStoreSalesTagetReducer from './erpStoreSalesTaget';
import erpStoreDataByDayReducer from './getERPStoreDataByDay';
import erpRoomListReducer from './erpRoomSlice';

// 合并 erp 模块下的所有 reducer
const erpStore = combineReducers({
  erpSalesReportHomeSummary: erpSalesReportHomeSummaryReducer,
  erpgetStoreAnnualStatistics: erpgetStoreAnnualStatisticsReducer,
  erpgetStoreList: erpgetStoreListReducer,
  erpStoreSalesTaget: erpStoreSalesTagetReducer,
  erpStoreDataByDay: erpStoreDataByDayReducer,
  erpRoomList: erpRoomListReducer,
});

export default erpStore;
